module.exports = __webpack_public_path__ + "img/00 banner.509164f0.png";